import React, { useEffect, useState } from "react";
import axios from "axios";
import config from "../../config";
import LoginChecked from "../Shared/LoginChecked";
import { Button, Form, Select, message, Row, Col } from "antd";
import { getDecimalPlaces, setDecimalPlacesLocal } from "../Shared/Utility";

const { Option } = Select;

function DecimalPlacesSetting() {
  const AccessKey = localStorage.getItem("AccessKey");
  const UserID = localStorage.getItem("ID");
  const userType = (
    localStorage.getItem("User_Type") ||
    localStorage.getItem("Member_Type") ||
    ""
  ).trim();
  const canEdit = userType.toLowerCase() !== "operator";

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    document.title = "Decimal Places Setting";
    setLoading(true);
    axios({
      method: "post",
      url: config.base_url + "Setting/GetDecimalPlaces",
      headers: { "Content-Type": "application/json" },
      data: { AccessKey, UserID },
    })
      .then((response) => {
        if (response.data.status_code == 1) {
          const places = response.data.DecimalPlaces;
          setDecimalPlacesLocal(places);
          form.setFieldsValue({ DecimalPlaces: places });
        } else {
          form.setFieldsValue({ DecimalPlaces: getDecimalPlaces() });
          message.error(response.data.status_message || "Unable to load setting");
        }
      })
      .catch(() => {
        form.setFieldsValue({ DecimalPlaces: getDecimalPlaces() });
        message.error("Unable to load setting");
      })
      .finally(() => setLoading(false));
  }, [AccessKey, UserID, form]);

  const handleSave = (values) => {
    if (!canEdit) {
      message.error("Only Admin/Manager can update this setting");
      return;
    }
    setSaving(true);
    axios({
      method: "post",
      url: config.base_url + "Setting/UpdateDecimalPlaces",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        DecimalPlaces: values.DecimalPlaces,
      },
    })
      .then((response) => {
        if (response.data.status_code == 1) {
          setDecimalPlacesLocal(response.data.DecimalPlaces);
          message.success(response.data.status_message);
        } else {
          message.error(response.data.status_message);
        }
      })
      .catch(() => message.error("Unable to update setting"))
      .finally(() => setSaving(false));
  };

  return (
    <>
      <LoginChecked />
      <div className="right-side-contents">
        <div className="page-content">
          <div className="page-header">
            <h3 className="page-title">Decimal Places</h3>
          </div>
          <p style={{ marginBottom: 24, maxWidth: 560 }}>
            Controls how many decimal places are shown in the app and reports.
            Stored values stay at full backend precision (up to 8 decimals).
            Default for new pumps is 4.
          </p>
          <Row>
            <Col xs={24} md={12} lg={8}>
              <Form
                form={form}
                layout="vertical"
                onFinish={handleSave}
                initialValues={{ DecimalPlaces: getDecimalPlaces() }}
              >
                <Form.Item
                  name="DecimalPlaces"
                  label="Decimal places"
                  rules={[{ required: true, message: "Please select decimal places" }]}
                >
                  <Select disabled={!canEdit || loading} size="large">
                    {[0, 1, 2, 3, 4, 5, 6, 7, 8].map((n) => (
                      <Option key={n} value={n}>
                        {n}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                {canEdit && (
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      size="large"
                      shape="round"
                      loading={saving}
                      disabled={loading}
                    >
                      Save
                    </Button>
                  </Form.Item>
                )}
              </Form>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
}

export default DecimalPlacesSetting;
